import React from 'react';

/**
 * An empty state must say which of the three things it means, because they
 * call for completely different responses:
 *
 *   "nothing has happened yet"  — expected, no action
 *   "we don't collect this"     — honest gap, don't fake a proxy number
 *   "the query returned none"   — your filter is too tight, widen it
 *
 * A bare "No data" collapses all three into a shrug.
 */
export default function EmptyState({ title, detail, action, tone = 'neutral' }) {
  const ring = tone === 'gap' ? 'border-dashed border-baseline' : 'border-hairline';
  return (
    <div className={`rounded-xl border ${ring} bg-surface px-5 py-8 text-center`}>
      <p className="text-sm font-medium text-ink">{title}</p>
      {detail && <p className="mx-auto mt-1 max-w-md text-xs text-ink-muted">{detail}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
